import {
  Box,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Radio,
  Typography,
} from "@mui/material";
import {MaterialSymbol} from "react-material-symbols";
import {IGetExamConfig} from "../../../../store/api/examConfigApiSlice";
import {BORDER_RADIUS_INNER} from "../../../../config/themes/theme";

interface ChapterListItemUIProps {
  chapterItem: IGetExamConfig["chapters"][string][number];
  isSelected: boolean;
  onClick: (chapterItem: IGetExamConfig["chapters"][string][number]) => void;
}
export default function ChapterListItemUI({
  chapterItem,
  isSelected,
  onClick,
}: ChapterListItemUIProps) {
  const lightColor = chapterItem.viewModel.color?.light ?? "primary.light";
  const mainColor = chapterItem.viewModel.color?.main ?? "primary.main";
  return (
    <ListItem
      key={chapterItem.id}
      secondaryAction={
        <Radio
          id={`radio-${chapterItem.id}`}
          size="small"
          checked={isSelected}
          onChange={() => onClick(chapterItem)}
          sx={{
            "&.Mui-checked": {
              color: chapterItem.viewModel.color?.main,
            },
          }}
        />
      }
      sx={{
        cursor: "pointer",
        bgcolor: isSelected ? lightColor : "secondary.light",
        borderRadius: BORDER_RADIUS_INNER,
        height: "100%",
      }}
      onClick={() => onClick(chapterItem)}>
      <ListItemIcon>
        <Box
          sx={{
            borderRadius: "50%",
            width: "44px",
            height: "44px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: isSelected ? mainColor : "primary.contrastText",
          }}>
          <MaterialSymbol
            icon={chapterItem.viewModel.icon ?? "sprint"}
            size={20}
            weight={500}
            color={"inherit"}
          />
        </Box>
      </ListItemIcon>
      <ListItemText
        primary={
          <Typography
            fontWeight={"500"}
            fontSize={"0.875rem"}
            sx={{
              color: isSelected ? mainColor : "primary.contrastText",
            }}>
            {chapterItem.viewModel.name}
          </Typography>
        }
        secondary={
          <Typography
            fontWeight={"400"}
            fontSize={"0.75rem"}
            sx={{
              opacity: 0.8,
              color: isSelected ? mainColor : "primary.contrastText",
            }}>
            {chapterItem.questionsCount}{" "}
            {chapterItem.questionsCount === 1 ? "question" : "questions"}
            &nbsp;•&nbsp;
            {chapterItem.topicsCount}{" "}
            {chapterItem.topicsCount === 1 ? "topic" : "topics"}
          </Typography>
        }
      />
    </ListItem>
  );
}
